import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { applyAppHeaders } from 'controls/appIdentity';

const baseQuery = fetchBaseQuery({
  baseUrl: '',
  prepareHeaders: (headers, { getState, arg }) => {
    const token = getState().user?.userInfo?.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    // Apply app headers only to our own back-end services
    return applyAppHeaders(headers, typeof arg === 'string' ? arg : arg?.url);
  },
});

export const apiSlice = createApi({
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  endpoints: () => ({}),
});
